export const teams_ChatAroundEmailButton = "aqvkt";
export const teams_ChatAroundEmailAllButton = "pbjhO";
export const Teams_ChatAroundEmailFlyoutButton = "deBoRb";
export const teams_ShareToTeamsChatButton = "TJ1aSd";
export const copyToButton = "oEzwRb";
export const myDayButton = "O3kuid";
export const myDayMenuShow = "yURwte";
export const myDayMenuHide = "BbFiue";
export const unifiedInboxSettingsButton = "HmSCDe";
export const folderSettingsButton = "D5ezCb";
export const favoriteSettingsButton = "Hy39K";
export const customSortButton = "n_4eBe";
export const lightRPOnButton = "BVoWLb";
export const lightRPOffButton = "ltagUd";
export const messageListOrganizationButton = "c8LOsc";
export const readingPaneMessageViewButton = "AyFE9c";
export const createQuickStep_Button = "UjaL4";
export default {teams_ChatAroundEmailButton,teams_ChatAroundEmailAllButton,Teams_ChatAroundEmailFlyoutButton,teams_ShareToTeamsChatButton,copyToButton,myDayButton,myDayMenuShow,myDayMenuHide,unifiedInboxSettingsButton,folderSettingsButton,favoriteSettingsButton,customSortButton,lightRPOnButton,lightRPOffButton,messageListOrganizationButton,readingPaneMessageViewButton,createQuickStep_Button};